import { Avatar, AvatarFallback, AvatarImage } from "@ui/components/avatar";
import { getStorageImageUrl } from "../lib/image-utils";
import { initialsFor } from "../lib/initials";

export function UserAvatar({
	name,
	avatarUrl,
	...props
}: React.ComponentProps<typeof Avatar> & {
	name: string;
	avatarUrl?: string | null;
}) {
	return (
		<Avatar {...props}>
			<AvatarImage src={getStorageImageUrl(avatarUrl) ?? undefined} />
			<AvatarFallback className="font-medium text-[0.75em]">
				{initialsFor(name)}
			</AvatarFallback>
		</Avatar>
	);
}
